import type { PickerRow } from 'api/canonicalPicker.types'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical')

const MAX_NAMES_SHOWN = 3

/**
 * How a pick is named outside the list: a store UID by its store's name, a
 * uid with no match by itself; the level's red line says it matches nothing.
 */
const pickNameOf = (row: PickerRow): string => {
  switch (row.kind) {
    case 'product':
    case 'uidGroup':
      return row.name
    case 'storeUid':
      return row.storeName
    case 'unmatchedUid':
      return row.uid
  }
}

/** The distinct names while they fit, a count of the picks once they don't */
const selectionSummary = (rows: PickerRow[]): string => {
  const names = new Set(rows.map(pickNameOf))

  if (names.size > MAX_NAMES_SHOWN) {
    return t('selected_count', { count: rows.length })
  }
  return Array.from(names).join(', ')
}

export default selectionSummary
